import { usePaymentApiV1 } from '../../../clients/quipli-service/payment/payment-api-v1';
import { useCallback, useEffect, useState } from 'react';
import { loadStripe, SetupIntent, Stripe } from '@stripe/stripe-js';
import { debounce } from 'lodash';
import { toast } from '../../../util/toasts';

export default function StripeSetupAuthorization({ gatewayResponse }: { gatewayResponse: SetupIntent }) {
  const { getStripeSettings } = usePaymentApiV1();

  const [stripe, setStripe] = useState<Stripe>();

  console.log('StripeSetupAuthorization', gatewayResponse);

  useEffect(() => {
    getStripeSettings().then((settings) => {
      loadStripe(settings.publishableKey, {
        stripeAccount: settings.accountType === 'standard' ? settings.connectedAccountId : undefined,
      }).then((stripe) => {
        if (stripe) {
          setStripe(stripe);
        } else {
          throw new Error('Unable to retrieve stripe instance');
        }
      });
    });
  }, []);

  async function authenticateSetup() {
    if (stripe) {
      const setupIntent = gatewayResponse;
      // @ts-expect-error not in description
      if (setupIntent.clientSecret && setupIntent.nextAction?.verifyWithMicrodeposits?.hostedVerificationUrl) {
        try {
          window.open(
            // @ts-expect-error not in description
            setupIntent.nextAction.verifyWithMicrodeposits.hostedVerificationUrl,
            '_blank',
            'noreferrer',
          );
        } catch (e: any) {
          toast('Unable to capture authentication', 'error');
        }
      }
    }
  }

  const authenticate = useCallback(
    debounce(function () {
      return authenticateSetup();
    }, 300),
    [stripe],
  );

  useEffect(() => {
    authenticate();
  }, [stripe]);

  return <></>;
}
